import { render, staticRenderFns } from "./LogoInverted.vue?vue&type=template&id=5c542eb8&"
import script from "./LogoInverted.vue?vue&type=script&lang=js&"
export * from "./LogoInverted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports